// extracted by mini-css-extract-plugin
export default {"themeIconLight":"ThemeIcon_themeIconLight__ejVso","themeIconDark":"ThemeIcon_themeIconDark__OVTJd"};